<template>
  <div class="post-item">
    <div class="post-item__wrapper">
      <a class="post-item__link" :href="link" />
      <div class="post-item__image">
        <img :src="image" v-if="image">
        <span class="post-item__topic" v-if="primaryTopic">{{ primaryTopic }}</span>
      </div>
      <div class="post-item__content">
        <h4 class="post-item__title">
          {{ title }}
        </h4>
        <a :href="link" class="btn btn--grey btn--smallest">Find Out More</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Resource',
  props: {
    link: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    primaryTopic: {
      type: String,
      default: ''
    }
  }
};
</script>

<style></style>
